module.exports = __webpack_public_path__ + "static/media/Group 11661.fb87c4ad.svg";